import axios from "axios"
import { IsBetaSite } from "../Components/GeneralFunctions";

//const mSigninBaseUrl = "https://signin-va.cloudcti.nl" + (IsBetaSite() ? "/signinbeta" : "/signin")
const mSigninBaseUrl = "https://signin-va.cloudcti.nl/signin"

export async function SigninApiGetToken(aUsername, aPassword, aSigninMethod) 
{
    try
    {
        const result = await axios.post(mSigninBaseUrl + "/api/token", 
            {
                ApplicationType: "WebClient2018",
                SigninMethod: aSigninMethod
            },
            {
                headers: {
                    Authorization: "Basic " + btoa(`${aUsername}:${aPassword}`),
                    Accept: "application/json",
                    ContentType: "application/json"
                }
            })
        return result.data
    }
    catch (ex)
    {
        try
        {
            return ex.response.data
        }
        catch
        {
            return null
        }
    }
}

export async function SigninApiTokenRefresh(aToken) 
{
    try
    {
        const result = await axios.post(mSigninBaseUrl + "/api/tokenrefresh", 
            {
                ApplicationType: "WebClient2018",
                SigninMethod: aSigninMethod
            },
            {
                headers: {
                    Authorization: "Bearer " + aToken,
                    Accept: "application/json",
                    ContentType: "application/json"
                }
            })
        return result.data
    }
    catch (ex)
    {
        try
        {
            return ex.response.data
        }
        catch
        {
            return null
        }
    }
}

export async function SigninApiGetTokenGntel(aUsername, aAccessToken, aRefreshToken, aSigninMethodUrl) 
{
    try
    {
        const result = await axios.post(mSigninBaseUrl + "/api/token", 
            {
                ApplicationType: "WebClient2018",
                SigninMethod: "gntel2025", //this one sets data in the quickaccessdata and then reverts to gntel
                SigninMethodUrl: aSigninMethodUrl

            },
            {
                headers: {
                    Authorization: "Basic " + btoa(`${aRefreshToken}:${aAccessToken}`),
                    Accept: "application/json",
                    ContentType: "application/json"
                }
            })
        return result.data
    }
    catch (ex)
    {
        try
        {
            return ex.response.data
        }
        catch
        {
            return null
        }
    }
}

export async function SigninApiSetUserSettingsKwebbl(aSecurityToken, aApiKey, aApiSecret, aAccessToken, aRefreshToken, aTokenExpirationTime, aUserAgent) 
{
    await axios.post(mSigninBaseUrl + "/api/usersettings/kwebbl", 
        {
            ApiKey: aApiKey,
            ApiSecret: aApiSecret,
            AccessToken: aAccessToken,
            RefreshToken: aRefreshToken,
            TokenExpirationTime: aTokenExpirationTime,
            UserAgent: aUserAgent
        },
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json",
                ContentType: "application/json"
            }
        })
}

export async function SigninApiGetUserSetting(aSecurityToken, aIdentifier) 
{
    try
    {
        const result = await axios.get(mSigninBaseUrl + "/api/usersetting?identifier=" + aIdentifier, 
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json"
            }
        })
        return result.data.Value
    }
    catch
    {
        return null
    }
}

export async function SigninApiSetUserSetting(aSecurityToken, aIdentifier, aValue) 
{
    await axios.patch(mSigninBaseUrl + "/api/usersetting", 
        {
            Identifier: aIdentifier,
            Value: aValue
        },
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json",
                ContentType: "application/json"
            }
        })
}